import {InjectionToken} from '@angular/core';

export const IS_DETACHED_WIDGET = new InjectionToken<boolean>('isDetachedWidget', {
    factory: () => false
});
